import React from 'react';

import {SupportedLanguage} from '../types';
import FormattedDate from './formatted-date';

interface PostDatesProps {
	date: string;
	updated_at: string;
	lang: SupportedLanguage;
}

function PostDates({date, updated_at, lang}: PostDatesProps) {
	const published =
		lang === 'ar'
			? `
		نُشرت في:
	`
			: 'Published on: ';
	const updated =
		lang === 'ar'
			? `
		آخر تعديل في:
	`
			: 'Last updated on: ';

	return (
		<>
			{published} <FormattedDate date={date} lang={lang} />{' '}
			{String.fromCodePoint(0x20_14)} {updated}{' '}
			<FormattedDate date={updated_at} lang={lang} />
		</>
	);
}

export default PostDates;
